import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import domain from '../domain'
import axios from 'axios'
import { MDBInput } from "mdbreact";
import moment from 'moment'
/**
 *  Home Page Popup Modal
 */

import colors from "../colors";
import ReactHTMLParser from "react-html-parser";
class DownloadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableDownload: false,
      purpose: null,
      organization: null,
      check: false,
      agency: null,
      stateinfo: null,
      disabled: false,
      country: null,
      enableothers: false,
    }
  }
  save = (type) => {
    const url = `${domain.DBServer}/save-glof-request`
    const data = {
      theme: 'GLOF',
      product: 'Glacial lakes',
      status: '0',
      user: this.props.user,

      purpose: this.state.purpose,
      state: this.props.stateselected,
      district: this.props.districtselected,
      river: this.props.river,
      subbasin: this.props.subbasin,
      type: type

    }
    axios.request({
      method: 'post',
      url: url,
      data: data,
    }).then((result) => {
      if (result) {
        console.log(result.data)
        if (result.data) {
          this.props.enableGLOFStatus(result.data.requestid)
          //this.props.getRequestID()
          this.props.toggle()
        }
      }
    })
  }
  handleDownloadLink = () => {
    const method = 'POST';
    if (this.props.basin !== '#' || this.props.subbasin !== '#') {
      let subbasin = this.props.subbasin.toLowerCase().split(" ").join("_")
      console.log(subbasin)



      const url = `${domain.Fileserver}/download_glof`
      axios
        .request({
          url,
          method,
          data: {
            basin: this.props.basin,
            river: this.props.river,
            subbasin: subbasin,


            user: this.props.user
          },
          responseType: 'blob', //important
        })
        .then((result) => {
          if (result) {
            const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `Glacial_Lakes_${this.props.river}_${this.props.basin}_${this.props.subbasin}.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        });
    }
    else {
      if (this.props.stateselected !== '#' && this.props.districtselected !== '#') {
        let state = this.props.stateselected.toLowerCase().split(" ").join("_")
        let district = this.props.districtselected.toLowerCase().split(" ").join("_")

        const url = `${domain.Fileserver}/download_glof_district`
        axios
          .request({
            url,
            method,
            data: {
              state: state,
              district: district,


              user: this.props.user
            },
            responseType: 'blob', //important
          })
          .then((result) => {
            if (result) {
              const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', `Glacial_Lakes_${state}_${district}.zip`);
              document.body.appendChild(link);
              link.click();
              link.remove();
            }
          });

      }
      else if (this.props.stateselected !== '#' && this.props.districtselected === '#') {
        let state = this.props.stateselected.toLowerCase().split(" ").join("_")

        const url = `${domain.Fileserver}/download_glof_state`
        axios
          .request({
            url,
            method,
            data: {
              state: state,



              user: this.props.user
            },
            responseType: 'blob', //important
          })
          .then((result) => {
            if (result) {
              const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', `Glacial_Lakes_${state}.zip`);
              document.body.appendChild(link);
              link.click();
              link.remove();
            }
          });
      }
    }
  };



  onSubmit = async (e) => {
    e.preventDefault();
    if (this.state.purpose !== null) {
      if (this.props.stateselected !== '#' && this.props.districtselected !== '#') {
        this.save('district')
      }
      else if (this.props.stateselected !== '#') {
        this.save('state')
      }
      else if (this.props.river !== '#' && this.props.subbasin !== '#') {
        this.save('subbasin')
      }
    }




  }
  handleCheck = (e) => {
    this.setState({
      check: e.target.value,
      disabled: true,

    })
  }
  changeCountry = (e) => {
    this.setState({
      country: e.target.value
    })
  }
  changeAgency = (e) => {
    this.setState({
      agency: e.target.value
    })
  }
  changeState = (e) => {
    this.setState({
      stateinfo: e.target.value
    })
  }
  changeOrg = (e) => {
    this.setState({
      organization: e.target.value
    })
  }
  changePurpose = (e) => {
    this.setState({
      purpose: e.target.value
    })
  }
  changePurpose_multiple=(e)=>{
    if(e.target.value!=='1')
    {
      let value = Array.from(e.target.selectedOptions, option => option.value);
      this.setState({ purpose: value,enableothers:false });

    }
    else{
      this.setState({
        enableothers:true,
        purpose:null
      })
    }
  }
  render() {
    console.log(this.props)
    return (
      <MDBContainer >

        <MDBModal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered
          backdrop={false}
          size="lg"

        >
          <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.props.toggle}
            style={{ background: "#3f51b5", color: "white" }}
          >
            {this.props.title}
          </MDBModalHeader>
          <MDBModalBody
            style={{
              textAlign: "justify",
              height: window.innerHeight > 1000 ? "500px" : "300px",

              overflow: "scroll",
            }}
          >
            <form onSubmit={this.onSubmit}>

              {/* // <div class="form-group row">
//                 <label for="inputcountry" class="col-sm-2 col-form-label">Country</label>
//                 <div class="col-sm-10">
//                   <input type="text" class="form-control" id="inputcountry" placeholder="Country" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.country} onChange={this.changeCountry} />
//                 </div>
//               </div>

//               <div class="form-group row">
//                 <label for="inputstate" class="col-sm-2 col-form-label">State</label>
//                 <div class="col-sm-10">
//                   <input type="text" class="form-control" id="inputstate" placeholder="State" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.stateinfo} onChange={this.changeState} />
//                 </div>
//               </div>
//               <div class="form-group row">
//                 <label for="inputorg" className="col-sm-2 col-form-label">Organization</label>
//                 <div class="col-sm-10">
//                   <input type="text" className="form-control" id="inputorg" placeholder="Organization" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.org} onChange={this.changeOrg} />
//                 </div>
//               </div>
//               <div class="form-group row">
//                 <label for="inputagency" class="col-sm-2 col-form-label">Agency</label>
//                 <div class="col-sm-10">
//                   <input type="text" class="form-control" id="inputagency" placeholder="Agency" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.agency} onChange={this.changeAgency} />
//                 </div>
//               </div> */}
            

            <div class="form-group row">
                <label for="inputpurpose" class="col-sm-3 col-form-label">Purpose
                <span style={{ color: "red" }}> &nbsp;
                    *(<i>Use Ctrl + left click or mouse dragging for multiple selections</i>)
                  </span></label>
                <div class="col-sm-8">
                 
                    <select
                    multiple="true"
                    className="custom-select"
                    name="hd"
                    id="hd" onChange={this.changePurpose_multiple} required>
                      <option value='Glacial lakes database'>Glacial lakes database</option>
                      <option value='	Monitoring  of glacial lakes'>	Monitoring  of glacial lakes</option>
                      <option value='Prioritisation of glacial lakes '>Prioritisation of glacial lakes </option>
                      <option value='GLOF risk assessment '>  GLOF risk assessment </option>
                      <option value='Climate change impact assessment '>  	Climate change impact assessment</option>
                      <option value='Planning GLOF mitigation  '>   Planning GLOF mitigation </option>
                      <option value="1">Others (please specify)</option>
                    </select>

                  
                 
                  <br/> <br/>
                  {
                    this.state.enableothers  ? <input type="text" onChange={this.changePurpose} value={this.state.purpose} required /> : null
                  }
                  {/* <textarea className="form-control" id="inputpurpose" rows="5" value={this.state.purpose}
                    pattern="[a-zA-Z 0-9]+" minlength="25" maxlength="1000" onChange={this.changePurpose} required ></textarea> */}
                </div>
               
              </div>
              <div class="form-group row col-sm-12 justify-content-center">
                <div className="custom-control custom-checkbox pl-3">
                  <input
                    className="custom-control-input"
                    type="checkbox"
                    value={this.state.check}
                    disabled={this.state.disabled}
                    id="invalidCheck"
                    required
                    onChange={this.handleCheck}
                  />
                  <label className="custom-control-label" htmlFor="invalidCheck">
                    I hereby agree to cite the usage of this product in the reports/publications appropriately.
    
              </label>

                </div>
              </div>
              <div class="form-group row justify-content-center">
                <div class="col-sm-12">
                  <p>Citation:</p>
                  <p style={{ textAlign: "justify" }}>NRSC, 2021, {this.props.product}, Geospatial hydro products developed by National Remote Sensing Centre under National Hydrology Project,&nbsp;
                  <a href={`${domain.bhuvannhpurl}`}>{domain.bhuvannhpurl}</a>, Last accessed:&nbsp;{moment(new Date()).format("DD-MMM-YYYY")}</p>
                </div>
              </div>
              <div class="form-group row d-flex justify-content-center">

                <button type="submit" class="btn btn-primary text-capitalize" size="sm">Submit</button>





              </div>




            </form>


            {this.state.enableDownload ? <button
              onClick={this.handleDownloadLink}
              class="btn btn-primary text-capitalize"

            ><a onClick={this.handleDownloadLink}>Download</a></button> :

              null}
          </MDBModalBody>
          {/* <MDBModalFooter>
            <MDBBtn
              onClick={this.props.toggle}
              style={{ backgroundColor: "#3f51b5" }}
            >
              Close
            </MDBBtn>
          </MDBModalFooter> */}
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default DownloadModal;
